import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';


export default function AddItem() {
  const navigate = useNavigate();
  const [box, setBox] = useState({ name: '', location: '', shelf: '', description: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    api(`/boxes`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(box),
    })
      .then(res => res.json())
      .then(data => navigate(`/storage/boxes/${data.id}`, { state: { saved: true } }));
  };

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Add Box</h1>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
            <input
              type="text"
              required
              value={box.name}
              onChange={(e) => setBox({ ...box, name: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Location</label>
            <input
              type="text"
              value={box.location}
              onChange={(e) => setBox({ ...box, location: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Shelf</label>
            <input
              type="text"
              value={box.shelf}
              onChange={(e) => setBox({ ...box, shelf: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
            />
          </div>
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
            <textarea
              value={box.description}
              onChange={(e) => setBox({ ...box, description: e.target.value })}
              rows={4}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
            />
          </div>
          <div className="flex gap-3">
            <button type="submit" className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">Save</button>
            <button type="button" onClick={() => navigate('/storage/boxes')} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Cancel</button>
          </div>
        </form>
      </div>
    </Layout>
  );
}
